export default __webpack_public_path__ + "static/media/about-splitter.ac0532b3.png";